<template lang="pug">
  .panel.panel-default(data-testid="card-tab-concpost")
    .panel-heading(v-if="addable || removable")
      .row
        .col-xs-6.text-left
          button.btn.btn-primary(v-if="addable", type="button", @click="openModalSelPerson" data-testid="-btn-add-concpost") 兼務に追加
        .col-xs-6.text-right
          button.btn.btn-danger(v-if="removable", type="button", @click="openRemove" data-testid="-btn-remove") 解除

    loading(v-if="isLoading")
    concpost-list(
      v-else-if="list.length > 0",
      v-model="list",
      :checkable="addable || removable",
      :pCheckedIds="checkedIds",
      :sort="currParams.sort",
      @checkAll="checkAll",
      @checkItem="checkItem",
      @clickCard="openCard"
    )
    .panel-body.text-center(v-else) 兼務に設定されている人物はいません。

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      //- 名刺情報
      modal-bcard(v-model="modalBcard")

      //- 人物選択（APIが単数選択にしか対応していないので、とりあえず単数選択）
      modal-sel-person(v-model="modalSelPerson", :maxSelect="1", matchingAlgo="2", :searchDefaultName="fullKana", @input="openAdd")

      //- 未選択
      app-modal(v-model="modalNoItem" type="info" data-testid="bcard-concpost-remove-noitem-modal")
        template(slot="title") 未選択
        h4 名刺を1件以上選択してください。

      //- 兼務追加確認
      app-modal(type="primary", v-model="modalAddConf.isOpen")
        template(slot="title") 兼務追加の確認
        h4 選択した人物を兼務として登録しますか？
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button", @click="submitAdd") 登録
          button.btn.btn-default(type="button", @click="close") キャンセル

      //- 兼務解除
      app-modal(type="danger", v-model="modalRemoveConf.isOpen" data-testid="bcard-concpost-remove-modal")
        template(slot="title") 兼務情報の解除
        h4 この兼務情報を解除してもよろしいですか？
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-danger(type="button", @click="submitRemove" data-testid="-btn-remove") 解除
          button.btn.btn-default(type="button", @click="close") キャンセル
</template>

<script>
import mixinList from '@/mixins/innerList'
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import ConcpostList from '@/components/organisms/lists/ConcpostList'
import ModalBcard from '@/components/organisms/ModalBcard'
import ModalSelPerson from '@/components/organisms/ModalSelPerson'
import AppModal from '@/components/templates/AppModal'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'CardTabConcurrent',
  components: {
    AppMessages,
    Loading,
    ConcpostList,
    ModalBcard,
    ModalSelPerson,
    AppModal
  },
  mixins: [ mixinList ],
  props: {
    sidPerson: { type: [String, Number], required: true },
    /**
     * @param {Object} POST /bcards のレスポンスのうち1件またはGET /persons/overview
     */
    value: { type: Object, required: true }
  },
  data () {
    return {
      isLoading: true,

      /*
       * 兼務追加
       */
      // 名刺人物選択モーダル
      modalSelPerson: {
        isOpen: false,
        selectedIds: [],
        selectedItems: []
      },

      /*
       * 兼務追加
       */
      // 追加確認モーダル
      modalAddConf: {
        isOpen: false,
        sidAssign: null
      },

      /*
       * 兼務解除
       */
      modalNoItem: false,
      // 解除確認モーダル
      modalRemoveConf: {
        isOpen: false,
        sidAssigns: []
      },

      // ソート項目リスト
      // sortOptions: [
      //   {'label': '氏名', 'sort_item': 'name'},
      //   {'label': '会社名', 'sort_item': 'corporate_name'},
      //   {'label': '部署名', 'sort_item': 'dept'},
      //   {'label': '役職', 'sort_item': 'post'},
      //   {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      // ],

      // // 初期条件
      // initParams: {
      //   // ページ条件
      //   page: {page: 1},
      //   // ソート条件
      //   sort: {sort_item: 'name', direction: 'asc'},
      //   // 検索条件
      //   conds: {}
      // },
      // 現在の条件
      currParams: {
        // ページ条件
        page: {page: 1},
        // ソート条件
        sort: {sort_item: 'name', direction: 'asc'},
        // 検索条件
        conds: {}
      },

      modalBcard: {
        isOpen: false,
        sidPerson: ''
      }
    }
  },
  computed: {
    isExchanged () {
      return this.value.isExchanged
    },
    fullKana () {
      return this.value.full_kana
    },
    addable () {
      return this.isMgmt || this.isExchanged === this.app_flag.ON
    },
    removable () {
      return this.list.length > 0 && this.addable
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.getList({ id: this.sidPerson })
      }
    },
    isOpen (isOpen) {
      if (isOpen) {
        this.getList({ id: this.sidPerson })
      }
    },
    sidPerson (id) {
      if (id) {
        this.getList({ id })
      }
    }
  },
  created () {
    if (this.sidPerson) {
      this.getList({ id: this.sidPerson })
    }
  },
  methods: {
    getList ({ id, page, sort, conds }) {
      const vm = this

      page = page || this.currParams.page
      sort = sort || this.currParams.sort
      conds = conds || this.currParams.conds

      let params = Object.assign({}, page, sort, conds)

      // 最後の検索条件を保持しておく
      this.currParams = { page, sort, conds }

      this.clearErrorMessages()
      this.isLoading = true

      // API実行
      PersonRepository.getConcposts(id, params, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response)
          vm.list = data.data
          // vm.pagination = data.pagination
          // vm.informationCount = vm.pagination.count
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '兼務情報が取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        .finally(function () {
          vm.isLoading = false
        })
    },
    openCard (item) {
      this.modalBcard.sidPerson = item.sid_person
      this.modalBcard.isOpen = true
    },
    /*
     * 名刺人物選択ダイアログを開く
     */
    openModalSelPerson () {
      this.modalSelPerson.isOpen = true
      // このページでは「OK」ボタン即API実行なので、前回の選択状態は開くたびにリセットする
      this.modalSelPerson.selectedIds = []
      this.modalSelPerson.selectedItems = []
    },
    /**
     * 兼務追加確認ダイアログを開く
     * value.isOpen
     * value.selectedIds
     * value.selectedItems
     */
    openAdd (value) {
      this.modalSelPerson.isOpen = true // 人物選択ダイアログは開いたまま

      if (!value.selectedIds.length) {
        this.modalSelPerson.isOpen = false
        return
      }

      const sidAssign = value.selectedIds[0]

      if (this.sidPerson === sidAssign) { // 本人
        this.showToast('本人は兼務に追加できません。', { type: 'danger' })
        // this.modalSelPerson.isOpen = false
        return
      }

      if (this.list.length) {
        for (let i in this.list) {
          if (this.list[i].sid_person === sidAssign) { // 選択済み
            this.showToast('この人物はすでに兼務に追加されています。', { type: 'danger' })
            // this.modalSelPerson.isOpen = false
            return
          }
        }
      }

      // 確認不要
      // this.modalAddConf.isOpen = true
      // this.modalAddConf.sidAssign = sidAssign
      this.submitAdd(sidAssign)
    },
    /**
     * 兼務追加APIを実行する
     */
    submitAdd (sidAssign) {
      this.modalSelPerson.isOpen = false
      // this.modalAddConf.isOpen = false

      const vm = this
      const id = this.sidPerson
      // const sidAssign = this.modalAddConf.sidAssign

      PersonRepository.postConcpost(id, sidAssign, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.getList({ id })
            vm.showToast('兼務人物を追加しました。', { type: 'success' })
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '兼務情報を追加できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    openRemove () {
      if (this.checkedIds.length) {
        this.modalRemoveConf.isOpen = true
        this.modalRemoveConf.sidAssigns = this.checkedIds
      }
      else {
        this.modalNoItem = true
      }
    },
    /**
     * 兼務を解除する
     */
    submitRemove () {
      const vm = this
      const id = this.sidPerson
      const sidAssigns = this.modalRemoveConf.sidAssigns

      // #616 APIを送信するごとにリセットする
      this.checkedIds = []
      this.checkedItems = []

      // APIが複数処理に未対応...
      let successMessageShown = false
      for (let sidAssign of sidAssigns) {
        // TODO [次期] await all
        PersonRepository.removeConcpost(id, sidAssign, this.isMgmt)
          .then(function (response) {
            if (vm.isApiSuccess(response)) {
              vm.getList({id})
              // 複数チェックしていても1回だけメッセージを表示する
              if (!successMessageShown) {
                vm.showToast('兼務人物を解除しました。', {type: 'success'})
                successMessageShown = true
              }
            }
          })
          .catch(function (error) {
            const message = vm.getErrorMessage(error) || '兼務情報を解除できませんでした。'
            vm.showToast(message, {type: 'warning'})
          })
          .finally(function () {
            vm.modalRemoveConf.isOpen = false
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabConcurrent.vue